module.exports = __webpack_public_path__ + "img/hero_google.df463613.webp";